export enum InsuranceProviderOption {
  BLUECROSS_BLUESHIELD = 1,
  UNITED_HEALTHCARE = 2,
  HIGHMARK = 3,
  CAREFIRST = 4,
  AETNA = 5,
  UMR = 6,
  OTHER = 7,
  NONE = 8,
  SKIP = 9,
}
